import { Box, Row } from "@stenajs-webui/core";
import { FlatButton, stenaSms } from "@stenajs-webui/elements";
import { Notification } from "@stenajs-webui/modal";
import type { FC } from "react";
import { useDispatch } from "react-redux";

import { UrgentMessageHTMLRenderer } from "../../../common-ui/UrgentMessageHTMLRenderer";
import { trackEvent } from "../../../common/tracking/trackerService";
import { showUrgentMessage } from "../../../services/modal/modalActions";
import { markUrgentMessageAsRead } from "../../../services/notifications/notificationsActions";
import type { UrgentMessageNotification as UrgentMessageNotificationType } from "../../../services/notifications/notificationsReducer";
import { getUrgentMessageIconProps } from "../toasts/getBookingResultParams";
import { formatToastRelativeTimestamp } from "../utils/formatToastRelativeTimestamp";

export interface UrgentMessageNotificationProps {
  messageIsRead: boolean;
  urgentMessageNotification: UrgentMessageNotificationType;
}

const onPressLink = (url: string) => {
  trackEvent({
    category: "NotificationCenter",
    action: "Pressed link in urgent message",
    label: url,
  });
};

export const UrgentMessageNotification: FC<UrgentMessageNotificationProps> = ({
  messageIsRead,
  urgentMessageNotification,
}) => {
  const dispatch = useDispatch();

  const onOpenClick = () => {
    const action = `Open urgent message (${messageIsRead ? "read" : "unread"})`;
    trackEvent({
      category: "NotificationCenter",
      action,
    });

    const { message } = urgentMessageNotification;
    dispatch(markUrgentMessageAsRead(message.id));
    dispatch(showUrgentMessage(message, "NotificationCenter", action));
  };
  return (
    <Notification
      variant={"standard"}
      {...getUrgentMessageIconProps()}
      text={urgentMessageNotification.message.header}
      timestamp={formatToastRelativeTimestamp(
        urgentMessageNotification.createdAt,
      )}
      unread={!messageIsRead}
    >
      <Box gap={2}>
        <div
          style={{
            overflowWrap: "break-word",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: "5",
            overflow: "hidden",
          }}
        >
          <UrgentMessageHTMLRenderer
            html={urgentMessageNotification.message.textHtml}
            onPressLink={onPressLink}
          />
        </div>
        <Row alignSelf={"flex-end"}>
          <FlatButton
            label={"Open full message"}
            leftIcon={stenaSms}
            onClick={onOpenClick}
          />
        </Row>
      </Box>
    </Notification>
  );
};
